 function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }


import safeRemoveNodeFromArray from '../../utils/relay/safeRemoveNodeFromArray'
import pluralizeHandler from './pluralizeHandler'

const handleRemoveAgendaItem = (
  agendaItemId,
  store,
  meetingId
) => {
  const agendaItem = store.get(agendaItemId)
  if (!agendaItem) return
  const teamId = agendaItem.getValue('id').split('::')[0]
  if (!teamId) return
  const team = store.get(teamId)
  safeRemoveNodeFromArray(agendaItemId, team, 'agendaItems')
  if (meetingId) {
    const meeting = store.get(meetingId)
    if (!meeting) return
    const phases = meeting.getLinkedRecords('phases')
    if (!phases) return
    const agendaItemPhase = phases.find((phase) => phase.getValue('phaseType') === 'agendaitems')
    if (!agendaItemPhase) return
    const stages = agendaItemPhase.getLinkedRecords('stages')
    if (!stages) return
    const stageToRemove = stages.find(
      (stage) =>
        _optionalChain([stage, 'access', _ => _.getLinkedRecord, 'call', _2 => _2('agendaItem'), 'optionalAccess', _3 => _3.getValue, 'call', _4 => _4('id')]) ===
        agendaItemId
    )
    if (!stageToRemove) return
    const stageId = stageToRemove.getValue('id') 
    if (!stageId) return
    safeRemoveNodeFromArray(stageId, agendaItemPhase, 'stages')
  }
}

const handleRemoveAgendaItems = pluralizeHandler(handleRemoveAgendaItem)
export default handleRemoveAgendaItems
